const LogoutBtn = (props) =>  {
    return (
        <a href="/logout" className='btn btn-danger' >Logout</a>
    );
}

export default LogoutBtn;